// AUTO-GENERATED by generate-rxdb-schemas.ts — DO NOT EDIT
// Copyright 2026 Epic Digital Interactive Media LLC
// SPDX-License-Identifier: Apache-2.0

import { defaultHooks } from '../defaults'

const name = 'vaultitems'

/**
 * VaultItem Model Interface (auto-generated from Drizzle schema)
 */
export interface VaultItemModel {
  id: string
  orgId: string
  workspaceId: string
  userId: string
  createdAt: string
  updatedAt: string
  metadata?: Record<string, unknown>
  extended?: Record<string, unknown>
  vaultId: string
  name: string
  type: string
  provider: string
  encryptedPayload: string
  iv: string
  authTag: string
  keyWraps: unknown[]
  keyVersion: number
  url?: string
  tags?: string[]
  notes?: string
  expiresAt?: string
  lastRotatedAt?: string
  lastAccessedAt?: string
  archived: boolean
  tenantId?: string
}

export const schema = {
  title: name,
  version: 0,
  primaryKey: 'id',
  type: 'object',
  properties: {
      "id": {
          "type": "string",
          "maxLength": 100
      },
      "orgId": {
          "type": "string",
          "maxLength": 100
      },
      "workspaceId": {
          "type": "string",
          "maxLength": 100
      },
      "userId": {
          "type": "string",
          "maxLength": 100
      },
      "createdAt": {
          "type": "string",
          "maxLength": 200,
          "format": "date-time"
      },
      "updatedAt": {
          "type": "string",
          "maxLength": 200,
          "format": "date-time"
      },
      "metadata": {
          "type": "object"
      },
      "extended": {
          "type": "object"
      },
      "vaultId": {
          "type": "string",
          "maxLength": 100
      },
      "name": {
          "type": "string",
          "maxLength": 500
      },
      "type": {
          "type": "string",
          "maxLength": 200
      },
      "provider": {
          "type": "string",
          "maxLength": 200
      },
      "encryptedPayload": {
          "type": "string",
          "maxLength": 100000
      },
      "iv": {
          "type": "string",
          "maxLength": 500
      },
      "authTag": {
          "type": "string",
          "maxLength": 500
      },
      "keyWraps": {
          "type": "array",
          "items": {}
      },
      "keyVersion": {
          "type": "integer"
      },
      "url": {
          "type": "string",
          "maxLength": 500
      },
      "tags": {
          "type": "array",
          "items": {
              "type": "string"
          }
      },
      "notes": {
          "type": "string",
          "maxLength": 5000
      },
      "expiresAt": {
          "type": "string",
          "maxLength": 200,
          "format": "date-time"
      },
      "lastRotatedAt": {
          "type": "string",
          "maxLength": 200
      },
      "lastAccessedAt": {
          "type": "string",
          "maxLength": 200
      },
      "archived": {
          "type": "boolean"
      },
      "tenantId": {
          "type": "string",
          "maxLength": 100
      }
  },
  required: [
      "id",
      "orgId",
      "createdAt",
      "updatedAt",
      "vaultId",
      "name",
      "type",
      "encryptedPayload",
      "iv",
      "authTag",
      "keyWraps",
      "keyVersion",
      "archived",
      "workspaceId",
      "userId",
      "provider"
  ],
  indexes: [
      [
          "orgId",
          "createdAt"
      ],
      [
          "vaultId",
          "createdAt"
      ],
      [
          "orgId",
          "workspaceId",
          "createdAt"
      ],
      [
          "userId",
          "createdAt"
      ],
      [
          "vaultId",
          "type"
      ],
      [
          "vaultId",
          "provider"
      ]
  ],
}

export const migrationStrategies = {}

export const Collection = {
  name,
  schema,
  hooks: {
    ...defaultHooks({ name }),
  },
  migrationStrategies,
}
